import Axios from "axios";

async function getTrendingClips() {
  const opt = {
    method: "GET",
    url: `${process.env.REACT_APP_API_URL}/items/clips?trending=true`,
  };
  try {
    return await Axios(opt);
  } catch (e) {
    return e.response;
  }
}

async function getUsersTrendingClips(userId) {
  const opt = {
    method: "GET",
    url: `${process.env.REACT_APP_API_URL}/items/clips?trending=true&user=${userId}`,
  };
  try {
    return await Axios(opt);
  } catch (e) {
    return e.response;
  }
}

export async function getUsersContactPreferences() {
  const opt = {
    method: "GET",
    url: `${
      process.env.REACT_APP_API_URL
    }/items/notifications/@me?token=${localStorage.getItem("token")}`,
  };
  try {
    return await Axios(opt);
  } catch (e) {
    return e.response;
  }
}
